module.exports = __webpack_public_path__ + "static/christianwork4-c05e14fa78692fa84afe3a973d96ab13.jpg";